import { buildQueryHelpers, OperationIds } from '../../util'
import { CollectionQueryKey } from '../../util/types'
import { boardObjectsCacheTransforms } from './cacheTransformFns'

export type BoardObjectsKey =
  CollectionQueryKey<OperationIds.ReadBoardObjectsV3>

export const readBoardObjects = {
  ...buildQueryHelpers<OperationIds.ReadBoardObjectsV3, BoardObjectsKey>(
    'board_object',
    OperationIds.ReadBoardObjectsV3
  ),
  transformCache: boardObjectsCacheTransforms,
}

/**
 * The inbox has no collection. The API filter spells that as the string
 * "null", and the key mirrors the filter so a query and its invalidation
 * cannot disagree.
 */
export const boardObjectsIdentifiers = {
  collection: ({
    workspaceUuid,
    boardId,
    collectionId,
  }: {
    workspaceUuid: string
    boardId: string
    collectionId: string | null
  }): BoardObjectsKey => ({
    workspaceUuid,
    queryParams: {
      filter: {
        board_id: boardId,
        board_object_collection_id: collectionId ?? 'null',
      },
    },
  }),
  board: ({
    workspaceUuid,
    boardId,
  }: {
    workspaceUuid: string
    boardId: string
  }): BoardObjectsKey => ({
    workspaceUuid,
    queryParams: { filter: { board_id: boardId } },
  }),
}
